module.exports = __webpack_public_path__ + "static/media/imagen-bimbo_enhanced.34510715.png";